import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from './locales/en.js'
import it from './locales/it.js'
import es from './locales/es.js'
import fr from './locales/fr.js'
import de from './locales/de.js'

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages: {
    en: en,
    it: it,
    es: es,
    fr: fr,
    de: de,
  }
})
